<mat-sidenav-container class="container" style="overflow: hidden">
  <mat-sidenav
    #sidenav
    [(mode)]="over"
    [(opened)]="opened"
    class="bottom-to-top"
  >
    <div class="with-bg"></div>
    <div
      class="h-50 example-1 square scrollbar-dusty-grass square thin"
      [style.background-color]="backgroundColorSideMenu"
    >
      <mat-nav-list>
        <mat-accordion multi="true" [displayMode]="displayMode">
          <mat-expansion-panel class="no-shadow" hideToggle>
            <mat-expansion-panel-header
              fxLayout="row"
              [expandedHeight]="expandHeight" 
              [collapsedHeight]="collapseHeight"
              style="background: none; margin: 0px -40px 0px -21px"
            >
              <mat-panel-title>
                <a
                  mat-list-item
                  (click)="sidenav.toggle(); ngOnInit()"
                  routerLink="/user/Menubar/home"
                  style="height: -webkit-fill-available"
                >
                  <span style="width: 10%; margin-right: 11px; margin-left: 5px"
                    ><em class="fas fa-home iconStyle"></em
                  ></span>
                  <span i18n="@@spmsMenuHome"><a>Home</a></span>
                </a>
              </mat-panel-title>
            </mat-expansion-panel-header>
          </mat-expansion-panel>

          <div class="row">
            <mat-tree
              [dataSource]="nestedDataSource"
              [treeControl]="nestedTreeControl"
              class="example-tree"
              style="width: 100%; padding-left: 17px; background: border-box"
            >
              <mat-tree-node
                *matTreeNodeDef="let node"
                style="min-height: 40px !important"
              >
                <button
                  mat-icon-button
                  class="tree-menu-item"
                  [routerLink]="['/user/Dynamic/dynamic']"
                  [queryParams]="{
                    screenType: node.screenType,
                    tableName: node.urlPath,
                    headerNameHtml: node.screenName,
                  }"
                  (click)="sidenav.toggle()"
                >
                  {{ node.screenName }}
                </button>
              </mat-tree-node>
              <!-- <mat-tree-node
                *matTreeNodeDef="let node"
                style="min-height: 40px !important"
              >
               <a
  mat-icon-button
  class="tree-menu-item side-menu-link"
  (click)="sidenav.toggle()"
  [routerLink]="['/user/Dynamic/dynamic']"
  [queryParams]="{
    screenType: node.screenType,
    tableName: node.urlPath,
    headerNameHtml: node.screenName
  }"
>
  {{node.screenName}}
</a>
              </mat-tree-node> -->
              <mat-nested-tree-node
                *matTreeNodeDef="let node; when: hasNestedChild"
              >
                <div style="border-bottom: 1px solid rgba(255, 255, 255, 0.18)">
                  <button
                    mat-icon-button
                    matTreeNodeToggle
                    style="
                      color: rgba(0, 0, 0, 0.8);
                      font-size: initial;
                      font-weight: normal;
                      display: flex;
                      padding-left: 60px;
                      width: 100%;
                      height: 40px;
                    "
                    class="tree-menu-item"
                  >
                    <mat-icon>
                      {{
                        nestedTreeControl.isExpanded(node)
                          ? "expand_more"
                          : "chevron_right"
                      }}
                    </mat-icon>
                    <em
                      class="{{ node.icon }}"
                      style="margin-left: 10px;  margin-right: 5px"
                    ></em>
                    {{ node.screenName }}
                  </button>
                </div>
                <ul
                  [class.example-tree-invisible]="
                    !nestedTreeControl.isExpanded(node)
                  "
                >
                  <ng-container matTreeNodeOutlet></ng-container>
                </ul>
              </mat-nested-tree-node>
            </mat-tree>
          </div>

          <mat-expansion-panel class="no-shadow" hideToggle>
            <mat-expansion-panel-header
              class="menu-item"
              fxLayout="row"
              [expandedHeight]="expandHeight"
              [collapsedHeight]="collapseHeight"
              style="
                background: rgba(0, 0, 0, 0) none repeat scroll 0% 0%;
                height: 39px;
                padding: 9px 0px 0px 23px;
              "
              (click)="logout()"
            >
              <mat-panel-title>
                <span style="width: 8%; margin-right: 15px"
                  ><em class="fas fa-sign-out-alt iconStyle"></em></span
                ><span i18n="@@spmsMenuAccesspermission"> Logout</span>
              </mat-panel-title>
            </mat-expansion-panel-header>
          </mat-expansion-panel>
        </mat-accordion>
      </mat-nav-list>
    </div>
  </mat-sidenav>
  <mat-sidenav-content *ngIf="!hideNav" class="page-wrap ...">
    <mat-toolbar
      color="primary"
      class="menuToolBar header-box-shadow"
      [style.background-color]="backgroundColorMenuHeader"
    >
      <button
        mat-icon-button
        (click)="sidenav.toggle()"
        fxShow.sm="true"
        fxShow.gt-sm="true"
      >
        <mat-icon>menu</mat-icon>
      </button>
      <div class="targetImage">
        <h2 class="projectTitle">JSuite</h2>
      </div>

      <span class="spacer"></span>

      <span class="spacer1"></span>
      <div class="round-toggle">
        <mat-icon
          class="info-icon"
          matTooltip="Help"
          (click)="onHelpClick()"
          style="cursor: pointer"
          >info</mat-icon
        >
      </div>
      <span class="spacer1"></span>
<div class="white-mat-field">
      <mat-form-field
        appearance="outline"
        style="margin-top: 28px; font-size: small; font-weight: 500"
      >
        <mat-label i18n="@@Targetstdcode">Select Workspace</mat-label>

        <mat-select
          [ngModelOptions]="{ standalone: true }"
          [(ngModel)]="name"
          (ngModelChange)="selectDns($event)"
        >
          <mat-option
            style="font-size: 15px"
            *ngFor="let eachdns of dnsnames"
            [value]="eachdns.url"
            [disabled]="isEnabled"
          >
            {{ eachdns.name }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
      <span class="spacer1"></span>
      <div class="round-toggle">
        <mat-slide-toggle
          id="myToggle"
          [checked]="toggleSelect"
          [(ngModel)]="togglestate"
          (change)="onToggleChange($event)"
          [matTooltip]="toolTipStatus"
          (click)="showConfirmationMessage($event)"
          [disabled]="!showToggle"
        >
        </mat-slide-toggle>
      </div>

      <span class="spacer1"></span>

      <!-- Logout button -->
      <div
        #menuTrigger="matMenuTrigger"
        [matMenuTriggerFor]="menu"
        class="iconview view overlay z-depth-2"
      >
        <label class="icontext img-fluid" alt="Responsive image">{{
          userIcon
        }}</label>
        <mat-icon></mat-icon>
        <mat-menu #menu="matMenu">
          <button
            mat-menu-item
            *ngFor="let profile of userProfile"
            (click)="profileAction(profile.value)"
          >
            <span class="Profile__Dropdown--Text">
              <span> <em class="{{ profile.icon }}"></em> </span>

              <span
                i18n="@@spmsMenuAccesspermission"
                style="margin-right: 10px"
              >
                {{ profile.name }}
              </span>
            </span>
          </button>
        </mat-menu>
      </div>
    </mat-toolbar>
    <main class="content">
      <router-outlet></router-outlet>
    </main>
  </mat-sidenav-content>

  <mat-sidenav-content *ngIf="hideNav" class="page-wrap ...">
    <mat-toolbar
      color="primary"
      class="jsipMenuToolBar header-box-shadow"
      [style.background-color]="backgroundColorMenuHeader"
      style="box-shadow: none; height: 7%"
    >
      <!-- <button mat-icon-button (click)="sidenav.toggle()" fxShow.sm="true" fxShow.gt-sm="true">
                <mat-icon>menu</mat-icon>
            </button>
            <div class="targetImage">
                <h2 class="projectTitle">JSuite</h2>
            </div> -->
      <!-- LEFT SECTION -->
      <div class="toolbar-left">
        <button mat-icon-button (click)="sidenav.toggle()">
          <mat-icon>menu</mat-icon>
        </button>

        <div class="targetImage">
          <h2 class="projectTitle">JSuite</h2>
        </div>
      </div>
      <!-- <span class="spacer"></span> -->
      <!-- CENTER SECTION -->
      <div class="toolbar-center">
        <!-- <div class="search-box">
      <input type="text" placeholder="Search..." />
      <mat-icon class="search-icon">search</mat-icon>
    </div> -->
        <div class="global-search">
          <!-- LEFT DROPDOWN -->
          <button class="search-category" [matMenuTriggerFor]="productMenu">
            {{ selectedCategory }}
            <mat-icon>arrow_drop_down</mat-icon>
          </button>

          <!-- SEARCH INPUT -->
          <div class="search-input-box">
            <input
              type="text"
              [(ngModel)]="searchText"
              (input)="onSearchInput()"
              placeholder="Search..."
            />

            <!-- <mat-icon class="binocular-icon">visibility</mat-icon> -->
            <mat-icon class="search-icon">search</mat-icon>

            <!-- Suggestion Dropdown -->
            <div
              class="search-suggestions"
              *ngIf="showSuggestions && productList.length > 0"
            >
              <div style="max-height: 275px; overflow-y: auto">
                <div
                  class="suggestion-heading"
                  style="
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                  "
                >
                  {{ selectedCategory }}
                  <button class="close-btn" (click)="closeSuggestions()">
                    <mat-icon>close</mat-icon>
                  </button>
                </div>

                <div
                  class="suggestion-item"
                  *ngFor="let product of productList"
                  (click)="selectProduct(product)"
                >
                  <!-- <mat-icon class="doc-icon">description</mat-icon> -->

                  <div class="suggestion-text">
                    <div class="product-name">{{ product.name }}</div>
                    <!-- <div class="product-id">{{ product.id }}</div> -->
                  </div>
                </div>
              </div>
            </div>
            <div
              class="search-suggestions"
              *ngIf="showSuggestions && alertList.length > 0"
            >
              <div style="max-height: 275px; overflow-y: auto">
                <div
                  class="suggestion-heading"
                  style="
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                  "
                >
                  {{ selectedCategory }}
                  <button class="close-btn" (click)="closeSuggestions()">
                    <mat-icon>close</mat-icon>
                  </button>
                </div>

                <div
                  class="suggestion-item"
                  *ngFor="let alert of alertList"
                  (click)="selectAlert(alert)"
                >
                  <!-- <mat-icon class="doc-icon">description</mat-icon> -->

                  <div class="suggestion-text">
                    <div class="product-name">{{ alert.ruleName }}</div>
                    <!-- <div class="product-id">{{ product.id }}</div> -->
                  </div>
                </div>
              </div>
            </div>
            <div
              class="search-suggestions"
              *ngIf="showSuggestions && reviewActivtyList.length > 0"
              style="width: 100%"
            >
              <div class="suggestion-scroll">
                <div
                  class="suggestion-heading"
                  style="
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                  "
                >
                  {{ selectedCategory }}
                  <button class="close-btn" (click)="closeSuggestions()">
                    <mat-icon>close</mat-icon>
                  </button>
                </div>

                <div class="suggestion-header">
                  <div>Activity Name</div>
                  <div>Product Name</div>
                  <div>Start Date</div>
                </div>

                <div
                  class="suggestion-row"
                  *ngFor="let reviewActivity of reviewActivtyList"
                  (click)="selectReviewActivity(reviewActivity)"
                >
                  <div>{{ reviewActivity.activityName }}</div>
                  <div>{{ reviewActivity.productName }}</div>
                  <div>{{ reviewActivity.activityStartDate }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <mat-menu #productMenu="matMenu" class="product-search-menu">
          <button mat-menu-item (click)="selectCategory('Products')">
            <mat-icon>policy</mat-icon>
            Products
          </button>

          <button mat-menu-item (click)="selectCategory('Review Activities')">
            <mat-icon>rate_review</mat-icon>
            Review Activities
          </button>

          <button mat-menu-item (click)="selectCategory('Signals')">
            <mat-icon>show_chart</mat-icon>
            Signals
          </button>

          <button mat-menu-item (click)="selectCategory('Alerts')">
            <mat-icon>notifications</mat-icon>
            Alerts
          </button>

          <!-- <button mat-menu-item class="child-item">Distributions</button>
  <button mat-menu-item class="child-item">Submissions</button> -->

          <!-- <button mat-menu-item>
    <mat-icon>folder_open</mat-icon>
    Localized Cases
  </button>

  <button mat-menu-item disabled>
    <mat-icon>folder_open</mat-icon>
    Aggregate Reports
  </button>

  <button mat-menu-item class="child-item">DSURs</button>
  <button mat-menu-item class="child-item">PBRERs</button>
  <button mat-menu-item class="child-item">PADER</button> -->
        </mat-menu>
      </div>
      <!-- <span class="spacer1"></span> -->

      <div class="toolbar-right">
        <div class="round-toggle">
          <mat-icon
            class="info-icon"
            matTooltip="Help"
            (click)="onHelpClick()"
            style="cursor: pointer; box-shadow: none !important"
            >info</mat-icon
          >
        </div>
        <span class="spacer1"></span>
<div class="white-mat-field">
        <mat-form-field
          appearance="outline"
          style="margin-top: 28px; font-size: small; font-weight: 500"
        >
          <mat-label i18n="@@Targetstdcode">Select Workspace</mat-label>

          <mat-select
            [ngModelOptions]="{ standalone: true }"
            [(ngModel)]="name"
            (ngModelChange)="selectDns($event)"
          >
            <mat-option
              style="font-size: 15px"
              *ngFor="let eachdns of dnsnames"
              [value]="eachdns.url"
              [disabled]="isEnabled"
            >
              {{ eachdns.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
</div>
        <!-- <span class="spacer1"></span> -->
        <div class="round-toggle">
          <mat-slide-toggle
            id="myToggle"
            [checked]="toggleSelect"
            [(ngModel)]="togglestate"
            (change)="onToggleChange($event)"
            [matTooltip]="toolTipStatus"
            (click)="showConfirmationMessage($event)"
            [disabled]="!showToggle"
          >
          </mat-slide-toggle>
        </div>

        <!-- <span class="spacer1"></span> -->

        <!-- Logout button -->
        <div
          #menuTrigger="matMenuTrigger"
          [matMenuTriggerFor]="menu"
          class="iconview view overlay"
          style="height: 35px; width: 35px"
        >
          <label
            class="icontext img-fluid"
            alt="Responsive image"
            style="margin-top: auto; margin-left: 7px"
            >{{ userIcon }}</label
          >
          <!-- <mat-icon></mat-icon> -->
          <mat-menu #menu="matMenu">
            <button
              mat-menu-item
              *ngFor="let profile of userProfile"
              (click)="profileAction(profile.value)"
            >
              <span class="Profile__Dropdown--Text">
                <span> <em class="{{ profile.icon }}"></em> </span>

                <span
                  i18n="@@spmsMenuAccesspermission"
                  style="margin-right: 10px"
                >
                  {{ profile.name }}
                </span>
              </span>
            </button>
          </mat-menu>
        </div>
      </div>
    </mat-toolbar>
    <div
      style="
        height: 5.5%;
        width: 100%;
        background: #f8f8f8;
        position: absolute;
        z-index: 99;
        margin-top: 3.57%;
      "
    >
      <div class="toolbar-scroll" #toolbarScroll>
        <div class="left-fixed">
          <button
            mat-button
            [matMenuTriggerFor]="appsMenu"
            style="
              width: fit-content;
              height: fit-content;
              border-radius: unset;
              margin-right: 10px;
              margin-left: 10px;
            "
          >
            <mat-icon style="font-size: 24px">apps</mat-icon>
            <span
              style="
                margin-left: 2px;
                font-size: 1rem;
                color: #1d1d1d;
                overflow: hidden;
                text-overflow: ellipsis;
                font-weight: normal;
                font-weight: 500;
              "
              >{{ selectedTopNavItem?.label }}</span
            >
          </button>
          <div
            role="separator"
            class="tabcollection-separator"
            style="
              border-right: 2px solid #ccc;
              height: 20px;
              margin-right: 10px;
            "
          ></div>
        </div>
        <!-- <p>{{selectedTopNavItem.label}}</p> -->
        <mat-menu #appsMenu="matMenu" class="apps-menu-panel">
          <ul class="apps-list">
            <li
              *ngFor="let item of topNavItems"
              (click)="selectTopNavItem(item)"
            >
              <mat-icon>{{ item.icon }}</mat-icon>
              <span>{{ item.label }}</span>
            </li>
          </ul>
        </mat-menu>
        <!-- Scrollable Right Section -->
        <!-- Main Navigation Area -->
        <div class="clean-nav" *ngIf="selectedTopNavItem">
          <!-- Visible Items (Configurable limit per module) -->
          <ng-container
            *ngFor="
              let subItem of getVisibleItems(selectedTopNavItem);
              let i = index
            "
          >
            <button
              mat-button
              class="nav-item"
              [ngClass]="{ active: currentSection === subItem.screenName }"
              (click)="handleNavClick(subItem, selectedTopNavItem?.label)"
            >
              <mat-icon>{{ subItem.icon }}</mat-icon>
              <span>{{ subItem.screenName }}</span>
            </button>
          </ng-container>

          <!-- Dropdown for Hidden Items (if any) -->
          <ng-container *ngIf="getHiddenItems(selectedTopNavItem).length > 0">
            <button
              mat-button
              class="nav-item"
              [matMenuTriggerFor]="moreMenu"
              [ngClass]="{ active: isDropdownItemActive(selectedTopNavItem) }"
            >
              <mat-icon>arrow_drop_down</mat-icon>
              <span>More</span>
            </button>

            <mat-menu #moreMenu="matMenu" class="apps-menu-panel">
              <ul class="apps-list">
                <li
                  *ngFor="let subItem of getHiddenItems(selectedTopNavItem)"
                  (click)="handleNavClick(subItem, selectedTopNavItem?.label)"
                >
                  <mat-icon>{{ subItem.icon }}</mat-icon>
                  <span>{{ subItem.screenName }}</span>
                </li>
              </ul>
            </mat-menu>
          </ng-container>
        </div>
      </div>
    </div>
    <main class="content">
      <router-outlet></router-outlet>
    </main>
  </mat-sidenav-content>
</mat-sidenav-container>
